import styles from '../ContentView.module.css'

import React from 'react'

import { LuX } from '@react-icons/all-files/lu/LuX'

import { Dialog, Flex, IconButton, ScrollArea, Text } from 'components/ds'

interface DescriptionModalProps {
  title: string
  description: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

const DescriptionModal = ({
  title,
  description,
  open,
  onOpenChange,
}: DescriptionModalProps): React.ReactNode => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="540px">
        <Flex justify="between" align="start" gap="4">
          <Dialog.Title translate="no">{title}</Dialog.Title>
          <Dialog.Close>
            <IconButton variant="ghost" color="gray" aria-label="Close">
              <LuX size={16} />
            </IconButton>
          </Dialog.Close>
        </Flex>
        <ScrollArea mt="4" className={styles.descriptionScrollArea}>
          <Text as="p" size="3" color="gray" translate="no">
            {description}
          </Text>
        </ScrollArea>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default DescriptionModal
